Vendd.Scripts.load(function () {
    if (venddProjectConfigs.phoneLocalizationEnabled) {
        initPhoneLocalization();
    }  
});

function initPhoneLocalization() {

    var formRow = document.getElementsByClassName("js-phone-localization");

    if (formRow.length < 1) return;

    for (var i = 0; i < formRow.length; i++) {
        initPlugin(formRow[i]);
    }
}

function initPlugin(item) {

    var input = item.querySelector("input");

    if (input.length < 1) return;

    var validationType = input.getAttribute("data-validation");
    var iti, itiOptions;

    var defaultItiOptions = {
        initialCountry: "sa",
        onlyCountries: ["sa"],
        countrySearch: false,
        nationalMode: false,
        formatOnDisplay: false,
        allowDropdown: false
    };

    if (validationType === "phone") {
        itiOptions = $.extend({}, defaultItiOptions, { placeholderNumberType: 'FIXED_LINE' });
    } else if (validationType === "mobile") {
        itiOptions = $.extend({}, defaultItiOptions, { placeholderNumberType: 'MOBILE' });
    } else if (validationType === "both") {
        itiOptions = $.extend({}, defaultItiOptions, { placeholderNumberType: 'FIXED_LINE_OR_MOBILE' });
    } else {
        itiOptions = defaultItiOptions;
    }

    iti = window.intlTelInput(input, itiOptions);

    const getSelectedDialCode = () => {
        const selectedCountry = iti.getSelectedCountryData();
        return selectedCountry?.dialCode ? `+${selectedCountry.dialCode}` : "";
    };

    const setDialCodeIfEmpty = () => {
        if (!input.value.trim()) {
            input.value = getSelectedDialCode();
        }
    };

    setDialCodeIfEmpty();

    input.addEventListener("countrychange", () => {
        if (!input.value.trim() || /^\+\d+\s*$/.test(input.value)) {
            input.value = getSelectedDialCode();
        }
    });

    input.addEventListener("blur", () => {
        if (!input.value.trim()) {
            input.value = getSelectedDialCode();
            return;
        }

        if (iti.isValidNumber()) {
            input.value = iti.getNumber();
        }
    });
}
